// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"190":"forum/components/SupportComposePage","458":"forum/components/SupportIndexPage","780":"forum/components/SupportSearchPage","907":"forum/components/SupportShowPage","993":"forum/components/SupportStatsModal"}[chunkId] + ".js";
};